import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { LoadOptions } from 'app/types-shared';

export const ACTION = {
  REQUEST_CODETABLE: 'CODETABLE_ADMINISTRATION:REQUEST_CODETABLE',
  RECEIVE_CODETABLE: 'CODETABLE_ADMINISTRATION:RECEIVE_CODETABLE',
  FAIL_CODETABLE: 'CODETABLE_ADMINISTRATION:FAIL_CODETABLE'
};

export class RequestCodetable {
  public type: string = ACTION.REQUEST_CODETABLE;
  constructor(public id: string, public loadOptionsParams: LoadOptions) {
  }
}

export class ReceiveCodetable {
  public type: string = ACTION.RECEIVE_CODETABLE;

  constructor(public id: string, public loadOptionsParams: LoadOptions, public codes: CodeComplexValue<number>[]) {
  }
}

export class FailCodetable {
  public type: string = ACTION.FAIL_CODETABLE;

  constructor(public id: string, public loadOptionsParams: LoadOptions) {
  }
}
